import axiosInstance from "../axiosInstance";
import { toast } from "react-toastify";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const changePassword = createAsyncThunk(
  "changePassword",
  async (data) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}/user/change-password`,
        data,
      );
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  },
);

export const fetchClients = async ({
  type,
  page = 1,
  pageSize = 10,
  sm_user_status,
}) => {
  try {
    const isInvitations = type === "invitations";

    const url = isInvitations ? "/invite/clientusers" : "/user/sitemembers";

    const params = isInvitations
      ? { page, pageSize: pageSize }
      : { page, pageSize: pageSize, sm_user_status };

    const response = await axiosInstance.get(
      `${process.env.REACT_APP_API_URL}${url}`,
      { params },
    );

    if (response.data.status === "success") {
      return response.data.data;
    }
  } catch (err) {
    toast.error(err.response.data.message);
  }
};

export const resendInvite = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_API_URL}/invite/resend`,
      data,
    );

    if (response.data.status === "success") {
      toast.success(response.data.message);
    }
  } catch (err) {
    toast.error(err.response.data.message);
  }
};

export const disableUser = async ({ clientId, data }) => {
  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_API_URL}/user/sitemember/${clientId}`, data
    );

    if (response.data.status === "success") {
      return response.data;
    }
  } catch (err) {
    toast.error(err.response.data.message);
  }
};

export const listOrganizations = async () => {
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_API_URL}/organization/list?page=1&pageSize=1000`
    );

    if (response.data.status === "success") {
      return response?.data;
    }
  } catch (err) {
    toast.error(err.response.data.message);
  }
};